import "./logo.scss";

const Logo = () => (
  <a href='/' alt='bear'>
    <img class="logoImage" src="/images/LogoWeb.png" alt="" />
  </a>
);

export default Logo;
